module.exports = __webpack_public_path__ + "img/7.943596e3.png";